<main class="cs">
  <section class="cs__card">
    <img src="assets/images/logo/skill2era-wordmark-color.png" alt="skill2era" class="cs__logo" width="891" height="341" />
    <h1 class="cs__title">{{ 'SPACES.CONTINUE_AS' | translate }}</h1>
    <p class="cs__sub">{{ 'SPACES.CHOOSE_HINT' | translate }}</p>

    <app-space-switcher variant="cards" [spaces]="spaces" (select)="choose($event)"></app-space-switcher>

    <label class="cs__remember">
      <input type="checkbox" [(ngModel)]="remember" />
      {{ 'SPACES.REMEMBER' | translate }}
    </label>

    <button type="button" class="cs__logout" (click)="logout()">
      <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ 'HEADER.LOGOUT' | translate }}
    </button>
  </section>
</main>
